import { DateFormat, formatDate } from '@chillibean/component-library';

import { StudyProtocol } from '../../models';
import * as actions from '../actions/types';

export const DEFAULT_FILTERED_DATA = [
  { id: 0, name: 'Show all' },
  { id: -1, name: 'No arms' },
];

export const initialState = {
  protocol: {
    data: undefined,
    error: false,
    loading: true,
  },
  protocolAction: {
    error: null,
    loading: false,
  },
  protocolUpdated: {
    data: false,
  },
  sitesAssignment: {
    error: null,
    loading: false,
  },
  studyEventDefinitionFilteredByStudyArm: {
    data: DEFAULT_FILTERED_DATA[0],
  },
};

export default function protocolReducer(state = initialState, { type, value } = {}) {
  switch (type) {
    case actions.SET_PROTOCOL:
      return { ...state, protocol: value };
    case actions.SET_PROTOCOL_ACTION:
      return { ...state, protocolAction: value };
    case actions.SET_PROTOCOL_STUDY_EVENT_PROCEDURE:
      return {
        ...state,
        protocol: {
          ...state.protocol,
          data: new StudyProtocol({
            ...state.protocol.data,
            createdAt:
              state.protocol.data.createdAt && formatDate(state.protocol.data.createdAt, DateFormat.ISO_DATE_TIME),
            issueDate: state.protocol.data.issueDate && formatDate(state.protocol.data.issueDate, DateFormat.ISO_DATE),
            studyArms:
              state.protocol.data.studyArms &&
              state.protocol.data.studyArms.map((studyArm) => ({
                ...studyArm,
                createdAt: studyArm.createdAt && formatDate(studyArm.createdAt, DateFormat.ISO_DATE_TIME),
              })),
            table: { ...state.protocol.data.table, studyEventProcedures: value },
          }),
        },
      };
    case actions.SET_STUDY_EVENT_DEFINITION_FILTERED_BY_STUDY_ARM:
      return { ...state, studyEventDefinitionFilteredByStudyArm: value };
    case actions.SET_STUDY_PROTOCOL_SITES_ASSIGNMENT_DATA:
      return { ...state, sitesAssignment: value };
    case actions.SET_PROTOCOL_UPDATED:
      return { ...state, protocolUpdated: value };
    default:
      return state;
  }
}
